export class FailedArtifactsController {

    constructor(FailedMessagesDao, $scope, GeneralSettingsDao, XRayUIModelSaver, $state, $filter, JFrogGridFactory,
                $q, JFrogModal, User, $window,$rootScope) {
        this.jfrogGridFactory = JFrogGridFactory;
        this.FailedMessagesDao = FailedMessagesDao;
        $rootScope.h1Header='Xray System Messages';
        this.$filter = $filter;
        $scope.$on('$destroy', () => {
            $rootScope.h1Heade='';
        });
        this.getFailureCount();
        this.modal = JFrogModal;
        this.init();
        this.$q = $q;
        this.$window = $window;
        this.user = User;
        this.$scope = $scope;
        this.defaultPagination = {direction: 'desc', num_of_rows: 15, order_by: 'step', page_num: 1};
        this.activeFilter = "all";
        this.artifactQuery = "";
        this.colorsDict = {
            event: '#da0001',
            index: 'blue',
            persist: 'darkturquoise',
            analysis: 'orange',
            alert: 'green',
            notify: 'black',
            artifactory_update: '#03a9f4'
        };
        this._createGrid();
        this.currentTab = 'failure_messages';
        this.TOOLTIPS = {
            scan: `Every time a new artifact or build is added to a connected Artifactory instance, Xray will scan it and its dependencies for known vulnerabilities and compliance violations and generate Issues accordingly. This process is called "Scanning".`,
            impact: `Every time new component metadata is available (vulnerabilities, licenses, etc.), Xray looks up the component in the components graph and if the update matches any watches, Xray will generate an issue and create a map of its impact to determine which artifacts are ultimately affected by it. This process is called "Impact Analysis".`
        }
        this.messagesTabs = [{name: 'failure_messages'}, {name: 'retry_messages'}];
        this.baseTabsDict = {failure_messages: 'Failiure Messages', retry_messages: 'Retry Messages'};
        this.messagesTabsDict = _.cloneDeep(this.baseTabsDict);

    }

    onChangeTab(tab) {
        console.log("Tab Changed", tab);
        this.currentTab = tab.name;
    }

    init() {
        this.stepsParams = {
            "impact/alert": true,
            "impact/analysis": true,
            "impact/notify": true,
            "impact/artifactory_update": true,
            "scan/alert": true,
            "scan/analysis": true,
            "scan/event": true,
            "scan/index": true,
            "scan/notify": true,
            "scan/persist": true,
            "scan/artifactory_update": true
        }
    }

    getFailureCount() {

        this.FailedMessagesDao.getSteps({}).$promise.then((steps) => {

            this.counters = {scan: [], impact: []};

            this.counters.scan = _.filter(steps.stats, (n) => {
                return n.step.indexOf('scan') > -1
            })
            this.counters.impact = _.filter(steps.stats, (n) => {
                return n.step.indexOf('impact') > -1
            })
        });

    }

    setActive(item) {
        /*if(item.count == 0 || !item.count){
            return;
        }*/
        if (this.activeFilter == item.step) {
            this.activeFilter = 'all';
        } else {
            this.activeFilter = item.step;
        }

        this.onFilterChange();
    }


    _createGrid() {
        this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowsPerPage(15)
            .setRowTemplate('default')
            .setColumns(this._getColumns())
            .setExternalPagination((pagination) => this.getData(pagination))
            .setMultiSelect()
            .setButtons(this.getActions())
            .setBatchActions(this.getBatchActions())
            .setGridData([]);

    }

    getData(pagination) {
        let defer = this.$q.defer();
        pagination = pagination || this.defaultPagination;
        let promise = '';
        let payload = {};
        var steps = [];
        _.each(this.stepsParams, (val, key) => {
            if (val) {
                steps.push(key);
            }
        });

        payload.steps = steps
        payload.subject = this.subjectQuery;

        if (!this.subjectQuery) {
            delete  payload.subject
        } else if (this.subjectQuery && this.subjectQuery.trim() == '') {
            delete  payload.subject
        }
        promise = this.FailedMessagesDao.getFailedMessages(pagination, payload).$promise;
        promise.then((results) => {
            if (!results.data.length) {
                this.noData = true;
            } else {
                this.noData = false;
            }
            this.gridOptions.setGridData(results.data);

            defer.resolve({})


        });

        return promise;
    }

    _getColumns() {
        return [
            {
                name: 'Subject',
                displayName: 'Subject',
                field: 'subject',
                cellTemplate: `<div ng-class="{'active':row.entity.step == grid.appScope.FailedArtifacts.currentHoveredStep}" class="ui-grid-cell-contents">{{row.entity.subject }}</div>`,

                width: '20%'
            },
            {
                name: 'Source',
                displayName: 'Source',
                cellTemplate: `<div ng-class="{'active':row.entity.step == grid.appScope.FailedArtifacts.currentHoveredStep}" class="ui-grid-cell-contents">{{row.entity.source }}</div>`,

                field: 'source',
                width: '20%'
            },
            {
                name: 'Step',
                displayName: 'Step',
                cellTemplate: `<div ng-class="{[row.entity.step.split('/')[1]]:'true','active':row.entity.step == grid.appScope.FailedArtifacts.currentHoveredStep}" class="ui-grid-cell-contents">{{row.entity.step }}</div>`,
                field: 'step',
                width: '20%'
            },
            {
                name: 'Timestamp',
                displayName: 'Timestamp',
                cellTemplate: `<div ng-class="{'active':row.entity.step == grid.appScope.FailedArtifacts.currentHoveredStep}" class="ui-grid-cell-contents">{{row.entity.timestamp | date:'medium' }}</div>`,
                field: 'timestamp',
                width: '20%'
            },
            {
                name: 'Error',
                displayName: 'Error',
                cellTemplate: `<div ng-class="{'active':row.entity.step == grid.appScope.FailedArtifacts.currentHoveredStep}" class="no-tooltip ui-grid-cell-contents">{{row.entity.error }}</div>`,
                field: 'error',
                width: '20%'
                /*customActions: [{
                    icon: 'icon icon-view',
                    tooltip: 'Read More',
                    callback: (row)=> {
                    console.log('Performing custom action 1 for ',row);
                    }
                }]*/
            }
        ];
    }

    refreshGrid() {
        if (this.gridOptions.api) {
            this.gridOptions.resetPagination();
        }
    }

    getText(count) {
        let prefix = '';
        let devider = 1;
        let fixedDecimal = 0;
        if (parseInt(count) > 999) {
            prefix = 'K';
            devider = 1000;
            if (parseInt(count) >= 1000000) {
                prefix = 'M';
                devider = 1000000;
            }
            fixedDecimal = 1;
        }

        let total = this.$filter('number')((parseInt(count) / devider).toFixed(fixedDecimal));

        return total + prefix
    }


    getBatchActions() {
        return [
            {
                icon: 'refresh',
                name: 'Retry Selected',
                callback: () => {

                    let selected = this.gridOptions.api.selection.getSelectedRows();


                    this.retryMessages(_.map(selected, 'id'), selected);
                }
            },
            {
                icon: 'clear',
                name: 'Delete Selected',
                callback: () => {

                    let selected = this.gridOptions.api.selection.getSelectedRows();
                    if (selected.length == 1) {
                        this.modal.confirm(
                            `Are you sure you want to delete <strong>${selected[0].subject} failure message</strong>?`)
                            .then(() => {
                                this.deleteMessages(selected[0].id, selected);
                            });
                    } else {
                        this.modal.confirm(
                            `Are you sure you want to delete <strong>${selected.length} failure messages</strong> ?`)
                            .then(() => {
                                this.deleteMessages(_.map(selected, 'id'), selected);
                            });
                    }
                }
            }
        ]
    };

    retryMessages(messages, selected = []) {


        let payload = {message_ids: []};

        if (typeof messages == 'string') {
            payload.message_ids.push(messages)
        } else {
            payload.message_ids = messages
        }


        this.FailedMessagesDao.retryMessage(payload).$promise.then((resp) => {


            if (!resp.error) {
                this.gridOptions.api.selection.clearSelectedRows();
                if (selected.length > 1) {
                    selected.forEach((row) => {
                        var index = this.gridOptions.data.indexOf(row);
                        this.gridOptions.data.splice(index, 1);
                    });
                } else if (selected.length == 1) {
                    var index = this.gridOptions.data.indexOf(selected[0]);
                    this.gridOptions.data.splice(index, 1);
                }
            }
            this.getData();
        });


    }

    deleteMessages(messages, selected = []) {


        let payload = {message_ids: []};

        if (typeof messages == 'string') {
            payload.message_ids.push(messages)
        } else {
            payload.message_ids = messages
        }

        this.FailedMessagesDao.deleteMessage(payload).$promise.then((resp) => {

            if (!resp.error) {
                this.gridOptions.api.selection.clearSelectedRows();
                if (selected.length > 1) {
                    selected.forEach((row) => {
                        var index = this.gridOptions.data.indexOf(row);
                        this.gridOptions.data.splice(index, 1);
                    });
                } else if (selected.length == 1) {
                    var index = this.gridOptions.data.indexOf(selected[0]);
                    this.gridOptions.data.splice(index, 1);
                }
            }
            this.getData();
        });


    }

    onFilterChange() {
        this.getData();
    }

    getActions() {
        return [
            {
                icon: 'icon icon-refresh',
                tooltip: 'Retry',
                callback: (row) => {

                    let tmpSelected = [row];
                    this.retryMessages(row.id, tmpSelected);
                }
            },
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => {

                    let tmpSelected = [row];
                    this.modal.confirm(
                        `Are you sure you want to delete <strong>${row.subject} failure message</strong>  ?`)
                        .then(() => {
                            this.deleteMessages(row.id, tmpSelected);
                        });

                }
            },
            {
                icon: 'icon icon-view',
                tooltip: 'Read More',
                callback: (row) => {
                    this.showErrorModal(row);
                }
            }
        ]
    };

    showErrorModal(row) {
        let modalScope = this.$scope.$new();
        modalScope.msg = row;

        let options = {windowClass: 'errors-modal'};

        this.modal.launchModalWithTemplateMarkup(require('../../../../modal_templates/show_error_modal.html'), modalScope, 'lg', true, options).result.then(() => {

        });
    }

    selecteAllSteps(type) {
        let changed = false;
        this.stepsParams = _.mapValues(this.stepsParams, (val, key) => {

            if (key.indexOf(type) > -1 && !val) {
                changed = true;
                return true;
            }
            return val;
        });
        if (changed) {
            this.getData().then(() => {
                this.refreshGrid()
            });
        }


    }

    unSelectAll(type) {
        let changed = false;
        this.stepsParams = _.mapValues(this.stepsParams, (val, key) => {

            if (key.indexOf(type) > -1 && val) {
                changed = true;
                return false;
            }
            return val;
        });
        if (changed) {
            this.getData().then(() => {
                this.refreshGrid()
            });
        }
    }

    downloadErrors() {
        let steps = [];
        _.each(this.stepsParams, (val, key) => {
            if (val) {
                steps.push(key);
            }
        });

        this.$window.open("ui/xray/ui/failedMessages/download?&steps=" + steps, "_self");
    }

    stepHovered(step) {

    }

    _jsonParser(msg) {
        let start = msg.indexOf('{');
        let end = msg.lastIndexOf('}');
        let json = msg.substr(start, end - start + 1);


        if (json[0] == '{' && json[json.length - 1] == '}') {

            let prased = JSON.parse(json);
        }
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/failed_artifacts/failed_artifacts.controller.js